<div class="w-full">
    <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
        <div class="flex items-center">
            <h6 mat-dialog-title class="font-semibold primary-font overflow-hidden break-words">{{data.data.fileName ?? 'Untitled'}}</h6>
        </div>
        <div class="flex items-center mr-1">
            <span (click)="closePdfViewer()"
                class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
                <em class="ti ti-x text-xl font-bold"></em>
            </span>
        </div>
    </div>
    <div class="flex flex-col zuper-dialog-body overflow-hidden ">
        <pdf-renderer (pdfError)="onPdfError($event)" [fileName]="data.data.fileName" [pdfSrc]="data.data.fileLink" ></pdf-renderer>
    </div>
</div>